/* XO — Celebrazione "spedizione gratuita sbloccata" (blocco F, F6+F3)
 *
 * Coriandoli + toast SOLO sulla transizione sotto→sopra soglia, su qualunque
 * pagina. Sostituisce il trigger Kalles via progressBarChange (disattivato con
 * hook in custom.js), che aveva due difetti misurati:
 *   1. la barra ha reveal-in-view: a drawer chiuso non emetteva nulla;
 *   2. l'anti-ripetizione (this.isShow) era in-memory: a ogni cambio pagina
 *      con carrello già sopra soglia i coriandoli ripartivano senza transizione.
 *
 * Qui lo stato precedente vive in sessionStorage e viene azzerato quando il
 * totale scende sotto soglia. Il load di pagina sincronizza lo stato in
 * silenzio: non è mai una transizione.
 *
 * Base di calcolo: cart.total_price (stessa base del checkout, regola XO).
 * L'evento cart:update di Kalles porta il totale solo per change/update;
 * per l'add (add.js non lo riporta) si fa una fetch di /cart.js.
 * cart:count:update NON è utilizzabile: porta il totale formattato (| money).
 */
(() => {
  'use strict';

  const root = document.getElementById('xo-shipping-celebration');
  if (!root) return;

  const threshold = parseInt(root.dataset.threshold, 10);
  if (!(threshold > 0)) return;

  const KEY = 'xo:freeship:above';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const msgEl = root.querySelector('[data-xo-msg]');

  const wasAbove = () => {
    try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  };
  const store = (above) => {
    try { sessionStorage.setItem(KEY, above ? '1' : '0'); } catch (e) { /* no-op */ }
  };

  /* Il toast è un popover manual: sta nel top layer, sopra il drawer (dialog).
     Fallback ad hidden per i browser senza Popover API. */
  const show = () => {
    if (msgEl) msgEl.textContent = root.dataset.message; // inserito ora: fa scattare aria-live
    root.removeAttribute('hidden'); // hidden è solo il default pre-JS: senza rimuoverlo vincerebbe sul popover
    if (typeof root.showPopover === 'function') {
      try { root.showPopover(); } catch (e) { /* già aperto */ }
    }
  };
  const hide = () => {
    if (typeof root.hidePopover === 'function') {
      try { root.hidePopover(); } catch (e) { /* già chiuso */ }
    } else {
      root.setAttribute('hidden', '');
    }
    if (msgEl) msgEl.textContent = '';
  };

  let toastTimer = null;
  let confettiTimer = null;

  /* Il drawer del carrello e' un <dialog> modale: quando Kalles lo apre, la
     spec Popover chiude ogni popover aperto (il toast morirebbe dopo pochi
     decimi di secondo, misurato). Con il drawer aperto il messaggio di
     soglia raggiunta spetta alla barra spedizione del drawer (F2): qui si
     mostrano solo i coriandoli, che sopravvivono al dialog. */
  const cartDrawerOpen = () => {
    const d = document.querySelector('#CartDrawer');
    return !!(d && (d.open || d.querySelector('dialog[open]')));
  };

  const celebrate = () => {
    if (!cartDrawerOpen()) {
      show();
      clearTimeout(toastTimer);
      toastTimer = setTimeout(hide, 4000);
    }

    if (!reducedMotion.matches) {
      // Listener già presenti in ConfettiElement (custom.js); finora orfani.
      document.dispatchEvent(new CustomEvent('confetti:start'));
      clearTimeout(confettiTimer);
      confettiTimer = setTimeout(() => {
        document.dispatchEvent(new CustomEvent('confetti:pause'));
      }, 2500);
    }
  };

  const onTotal = (total) => {
    if (typeof total !== 'number' || Number.isNaN(total)) return;
    const above = total >= threshold;
    if (above && !wasAbove()) celebrate();
    store(above);
  };

  // Sincronizzazione silenziosa allo stato reso dal server.
  const initial = parseInt(root.dataset.cartTotal, 10);
  if (!Number.isNaN(initial)) store(initial >= threshold);

  let fetching = false;
  let queued = false;
  const fetchTotal = () => {
    // Se una fetch e' in corso non si scarta la richiesta: si accoda una
    // rilettura. Due add ravvicinati possono far arrivare la prima risposta
    // con un totale gia' vecchio; scartare la seconda perderebbe la transizione.
    if (fetching) { queued = true; return; }
    fetching = true;
    const rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(rootPath + 'cart.js')
      .then((r) => r.json())
      .then((c) => onTotal(c.total_price))
      .catch(() => { /* rete: si riallinea al prossimo evento o load */ })
      .finally(() => {
        fetching = false;
        if (queued) { queued = false; fetchTotal(); }
      });
  };

  const onCartEvent = (evt) => {
    const total = evt && evt.detail && evt.detail.cartData && evt.detail.cartData.total_price;
    if (typeof total === 'number') { onTotal(total); return; }
    fetchTotal();
  };

  document.addEventListener('cart:update', onCartEvent);
  // Sconti: CartDiscount applica il codice e emette solo cart:reload.
  document.addEventListener('cart:reload', onCartEvent);
})();
